// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import config from '../Config.json';

// const API = (config.apiBaseUrl || "").replace(/\/$/, "");

// const getAuthToken = () => {
//     return (
//         localStorage.getItem("accessToken") ||
//         localStorage.getItem("auth") ||
//         localStorage.getItem("authToken") ||
//         localStorage.getItem("token") ||
//         null
//     );
// };

// export const fetchUsers = createAsyncThunk(
//     "users/fetchUsers",
//     async (_, { rejectWithValue }) => {
//         try {
//             const token = getAuthToken();
//             const headers = token ? { Authorization: `Bearer ${token}` } : {};

//             const url = `${API}/Accounts/GetUserInfo`;
//             const response = await fetch(url, { headers });

//             if (!response.ok) {
//                 const text = await response.text();
//                 throw new Error(`API ${response.status}: ${text || response.statusText}`);
//             }

//             const json = await response.json();
//             let data = null;
//             if (Array.isArray(json)) data = json;
//             else if (Array.isArray(json.items)) data = json.items;
//             else if (Array.isArray(json.data)) data = json.data;
//             else if (Array.isArray(json.users)) data = json.users;
//             else if (json && typeof json === "object") data = json;

//             console.debug("Fetched users (normalized):", data);
//             return data;
//         } catch (err) {
//             console.error("fetchUsers error:", err);
//             return rejectWithValue(err.message || "Failed to fetch users");
//         }
//     }
// );

// const userSlice = createSlice({
//     name: "users",
//     initialState: {
//         data: [],
//         loading: false,
//         error: null,
//     },
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             .addCase(fetchUsers.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(fetchUsers.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.data = action.payload || [];
//             })
//             .addCase(fetchUsers.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || action.error.message;
//             });
//     },
// });

// export default userSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from '../Config';

const getAPI = () => (config.apiBaseUrl || "").replace(/\/$/, "");
// API CALL
export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${getAPI()}/Accounts/GetUserInfo`
      );

      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const userSlice = createSlice({
  name: "users",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;